/** Persisted checkout snapshot (refresh / fallback). */
export const CHECKOUT_BOOKING_STORAGE_KEY = "orbi_checkout_booking_v1";

/** Newer-than-history snapshot from booking page (edit → check fare → back). */
export const BOOKING_DRAFT_STORAGE_KEY = "orbi_booking_draft";

/** Align session draft with latest Check Fare payload so nothing stale survives for Back/refresh. */
export function writeSessionBookingDraft(data) {
  if (typeof sessionStorage === "undefined" || !data) return;
  try {
    sessionStorage.removeItem(CHECKOUT_BOOKING_STORAGE_KEY);
    sessionStorage.setItem(
      BOOKING_DRAFT_STORAGE_KEY,
      JSON.stringify({ ts: Date.now(), data }),
    );
  } catch (_) {
    /* quota / private mode */
  }
}
